// extracted by mini-css-extract-plugin
export default {"globalDihkFont":"ReportTemplate_globalDihkFont__ZhACR","pageContent":"ReportTemplate_pageContent__0rHEK"};